import { useContext } from 'react';
import { SnackbarContext } from './context';

/**
 *
 * This hook context should be available globally and should not require the creation of new providers
 */
export function useSnackbarContext() {
	const context = useContext(SnackbarContext);
	if (!context) {
		throw new Error('useSnackbarContext must be used within a SnackbarContextProvider');
	}
	return context;
}
